module.exports = __webpack_public_path__ + "7a8fd77d36639dff88bd665c7ca1c281.pdf";